import { logError } from '@shared/log';
import posthog from 'posthog-js';

interface PosthogConfig {
  projectToken: string;
  apiHost: string;
}

export function posthogInit(config: PosthogConfig): boolean {
  try {
    // Default config values
    // {
    //   api_host: 'https://app.posthog.com',
    //   api_method: 'POST',
    //   autocapture: true,
    //   rageclick: false,
    //   api_transport: 'XHR',
    //   cookie_expiration: 365,
    //   cross_subdomain_cookie: true,
    //   debug: false,
    //   disable_persistence: false,
    //   ip: true,
    //   opt_out_capturing_by_default: false,
    //   opt_out_persistence_by_default: false,
    //   opt_out_capturing_persistence_type: 'localStorage',
    //   opt_out_capturing_cookie_prefix: null,
    //   persistence: 'cookie',
    //   persistence_name: '',
    //   property_blacklist: [],
    //   secure_cookie: false,
    //   capture_pageview: true,
    //   upgrade: false,
    //   disable_session_recording: false,
    //   xhr_headers: {},
    //   inapp_protocol: '//',
    //   inapp_link_new_window: false,
    //   session_recording: {
    //     blockClass: 'ph-no-capture',
    //     blockSelector: null,
    //     ignoreClass: 'ph-ignore-input',
    //     maskAllInputs: false,
    //     maskInputOptions: {},
    //     maskInputFn: null,
    //     slimDOMOptions: {},
    //     collectFonts: false
    //   },
    //   mask_all_element_attributes: false,
    //   mask_all_text: false
    // }
    posthog.init(config.projectToken, {
      api_host: config.apiHost,
      //Recommended defaults for posthog breaking changes
      //ref: https://posthog.com/docs/libraries/js/config
      defaults: '2026-01-30',
      capture_heatmaps: true,
      secure_cookie: true,
      person_profiles: 'always',
      mask_all_text: true,
      mask_all_element_attributes: true,
      rageclick: true,
      capture_exceptions: true,
      capture_performance: true,
    });
    return true;
  } catch (error) {
    logError(posthogInit, 'Error initializing PostHog:', { error });
    return false;
  }
}

export function posthogIdentifyUser(userId: string, properties: Record<string, any>) {
  try {
    posthog.identify(userId, properties);
  } catch (error) {
    logError(posthogIdentifyUser, 'Error identifying user in PostHog:', { error });
  }
}

export function posthogReset() {
  try {
    posthog.reset();
  } catch (error) {
    logError(posthogReset, 'Error resetting PostHog:', { error });
  }
}
